export default "__VITE_ASSET__Cm1E_cIg__"